import classNames from "classnames";

import {
  ArticleIcon,
  DataObjectIcon,
  ImageIcon,
  ListAltIcon,
  MapIcon,
  TimelineIcon,
  ViewInArIcon as ViewInAr,
} from "@/shared/foundation/icons/mui";
import { PanelType } from "@/shared/state/visualization";

interface PanelIconProps {
  className?: classNames.Argument;
  panelType: PanelType;
}

export function PanelIcon({ className, panelType }: PanelIconProps) {
  if (panelType === PanelType.Document) {
    return <ArticleIcon className={classNames(className)} />;
  }
  if (panelType === PanelType.Image) {
    return <ImageIcon className={classNames(className)} />;
  }
  if (panelType === PanelType.Log) {
    return <ListAltIcon className={classNames(className)} />;
  }
  if (panelType === PanelType.Plot) {
    return <TimelineIcon className={classNames(className)} />;
  }
  if (panelType === PanelType.ThreeD) {
    return <ViewInAr className={classNames(className)} />;
  }
  if (panelType === PanelType.RawMessage) {
    return <DataObjectIcon className={classNames(className)} />;
  }
  if (panelType === PanelType.Map) {
    return <MapIcon className={classNames(className)} />;
  }
  return null;
}
